import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Quanto tempo dura o tratamento em uma clínica de reabilitação?",
    answer:
      "A duração média varia de 90 a 180 dias, dependendo da evolução e das necessidades individuais do paciente. O plano terapêutico é reavaliado periodicamente pela equipe multidisciplinar.",
  },
  {
    question: "Qual a diferença entre internação voluntária e involuntária?",
    answer:
      "A internação voluntária ocorre por decisão do próprio paciente, enquanto a involuntária é solicitada por familiares ou responsáveis legais e requer laudo médico. Ambas são amparadas por lei e visam a recuperação do paciente.",
  },
  {
    question: "Como escolher a melhor clínica de reabilitação?",
    answer:
      "Compare estrutura física, equipe médica, tipos de tratamento oferecidos, avaliações de outros pacientes e localização. No Busca Clínicas você pode filtrar por estado, cidade, tipo de tratamento e faixa de preço.",
  },
  {
    question: "O tratamento é sigiloso?",
    answer:
      "Sim. Todas as clínicas cadastradas seguem rigorosos protocolos de sigilo e confidencialidade, conforme o Código de Ética Médica e a LGPD. Os dados do paciente são protegidos em todas as etapas.",
  },
  {
    question: "As clínicas aceitam planos de saúde?",
    answer:
      "Muitas clínicas cadastradas aceitam convênios e planos de saúde como Unimed, Bradesco Saúde, SulAmérica, Amil, Hapvida e outros. Utilize os filtros de busca para encontrar clínicas compatíveis.",
  },
  {
    question: "Familiares podem visitar durante a internação?",
    answer:
      "Sim. A maioria das clínicas permite visitas em dias e horários programados. O acompanhamento familiar é parte essencial do processo de recuperação e fortalecimento dos vínculos.",
  },
];

export default function LandingFAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="max-w-3xl mx-auto px-4 py-12">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <h2 className="text-2xl font-bold text-foreground text-center mb-2">
        Perguntas Frequentes
      </h2>
      <p className="text-muted-foreground text-center text-sm mb-8">
        Tire suas dúvidas sobre clínicas de reabilitação e tratamento
      </p>
      <Accordion type="single" collapsible className="space-y-2">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="border border-border/50 rounded-lg px-4 bg-card"
          >
            <AccordionTrigger className="text-sm font-medium text-foreground hover:no-underline">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
